import React, { ReactNode } from 'react'
import { ClientSecureWrapper } from './client/ClientSecureWrapper'

interface Props {
  children?: ReactNode
  footer?: ReactNode
  onBack?: () => void
}

export const SecureWrapper = ({ children, footer, onBack }: Props) => {
  return <ClientSecureWrapper children={children} footer={footer} onBack={onBack} />
}
